export const LOCAL_STORE_TOKEN = 'Token';
export const LOCAL_STORE_TOKEN_MARKETING = 'MarketingToken';
